<div class="agpr-columns-container">
    <div class="agpr-left-column">
        <label class="agpr-column-header">{{'Discover.recipientEditor.labels.chooseRecipients' | localize }}</label>

        <div class="agpr-recipientFilter">
            <div>
                <agpr-tabs
                    [tabsHeadingLevel]="4"
                    [selectedTabIndex]="selectedTabIndex"
                    (selectedTabIndexChange)="tabChange($event)"
                >
                    <agpr-tab
                        [icon]="'fa-kit-duotone fa-agpr-lists'"
                        [heading]="'Discover.recipientEditor.labels.lists'"
                        [id]="'contactEditor_lists'"
                    >
                    </agpr-tab>
                    <agpr-tab
                        [icon]="'fa-regular fa-duotone fa-folder-magnifying-glass'"
                        [heading]="'Discover.recipientEditor.labels.searches'"
                        [id]="'contactEditor_savedSearches'"
                    >
                    </agpr-tab>
                    <agpr-tab
                        *ngIf="openAiPermission"
                        [icon]="'fa-kit-duotone fa-agpr-ai-contacts'"
                        [heading]="'Common.forms.richText.agilityAgent'"
                        [id]="'contactEditor_openAI'"
                    >
                    </agpr-tab>
                </agpr-tabs>
            </div>

            <div
                *ngIf="sourceType != sourceTypes.openAI"
                class="agpr-recipientFilter-row"
            >
                <div class="agpr-recipientFilter-row-filterContainer">
                    <agpr-filter-dropdown
                        id="recipientEditor.filterDropdown"
                        [showQuickFilter]="true"
                        [quickFilterPlaceholder]="quickFilterPlaceholder"
                        [ariaLabel]="quickFilterPlaceholder | localize"
                        [ariaDescribedBy]="'editRecipientChips'"
                    ></agpr-filter-dropdown>
                    <!--
                        // currently not being used, but might add it down the road
                        <agpr-button
                        *ngIf="sourceType === sourceTypes.mailingLists"
                        class="agpr-recipientFilter-manageButton"
                        icon='fa-regular fa-gear'
                        tooltip='Common.mailingLists.picker.manage'
                        (click)="openManageMailingLists()"
                        [style]="buttonTypes.block"
                    >
                    </agpr-button> -->
                </div>
                <div
                    class="agpr-recipientFilter-chips"
                >
                    <agpr-filter-chips
                        class="agpr-recipientFilter-row-chipsContainer"
                        id="editRecipientChips"
                    ></agpr-filter-chips>
                </div>
            </div>

        </div>

        <ng-container
            *ngIf="sourceType != sourceTypes.openAI"
        >
            <div class="agpr-middle-row">
                <div class="agpr-middle-row-left">
                    <span class="agpr-middle-row-totalLabel">
                        {{
                            'Discover.recipientEditor.labels.recipientTotal' | localize: {
                                selected: recipientInformation?.getGroupRecipientsBySourceType(sourceType).length,
                                total: recipientRows.length
                            }
                        }}
                    </span>
                    <agpr-button
                        *ngIf="sourceType === sourceTypes.lists"
                        [tooltip]="'Discover.distribution.actions.buildANewList'"
                        [style]="buttonTypes.icon"
                        class="agpr-middle-row-button"
                        icon="fa-regular fa-duotone fa-square-plus"
                        (click)="createNewRecipientGroup(sourceTypes.lists)"
                    >
                    </agpr-button>
                    <agpr-button
                        *ngIf="sourceType === sourceTypes.searches"
                        [tooltip]="'Discover.distribution.actions.createANewSearch'"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-square-plus"
                        class="agpr-middle-row-button"
                        (click)="createNewRecipientGroup(sourceTypes.searches)"
                    >
                    </agpr-button>
                </div>

                <div *ngIf="openAiPermission" class="agpr-recipientEditor-copilot-button">
                    <agpr-button
                        [id]="'distributions_find_contacts'"
                        [label]="'Discover.recipientEditor.prCoPilot.findContacts'"
                        [icon]="'fa-kit-duotone fa-agpr-ai-contacts'"
                        [style]="buttonTypes.primary"
                        [disabled]="!distributionId"
                        [tooltip]="!distributionId ? 'Discover.recipientEditor.prCoPilot.noAccess' : ''"
                        (click)="findContacts()"
                    ></agpr-button>
                    <i
                        class="fa-regular fa-circle-info agpr-infoIconStyle"
                        [agprTooltip]="'Discover.recipientEditor.prCoPilot.findContacts.tooltip'"
                        [escape]="false"
                    ></i>
                </div>
            </div>

            <agpr-table
                id="recipientListTable"
                class="agpr-recipient-picker-scrollpanel"
                [ngClass]="{
                    'agpr-recipient-picker-scrollpanel-noContent': !recipientRows || !recipientRows.length
                }"
                [columns]="columnDefs"
                [sortColumn]="nameColumn"
                [showView]="sourceType === sourceTypes.lists || sourceType === sourceTypes.searches"
                [viewIcon]="'fa-duotone fa-regular fa-up-right-from-square'"
                [viewIconTooltip]="viewIconLabel"
                [sortAscending]="true"
                [(ngModel)]="recipientRows"
                (itemChanged)="selectionChanged($event)"
                (itemView)="view($event)"
                [enableSelectAll]="false"
                [vsItemSize]="35"
                [vsMinBufferPx]="350"
                [vsMaxBufferPx]="700"
            >
            </agpr-table>
            <agpr-message
                *ngIf="!recipientRows || !recipientRows.length"
                [severity]="messageSeverityEnum.noContent"
            >
                {{ noContentMessage }}
            </agpr-message>
        </ng-container>

        <ng-container
            *ngIf="sourceType === sourceTypes.openAI"
        >
            <agpr-scroll-panel>
                <div class="agpr-recipientEditor-copilotOutterHeight">
                    <div
                        class="agpr-recipientEditor-copilot agpr-recipientEditor-copilot-morePadding"
                    >
                        <img [src]="appBaseHref + recipientIcon" alt="" height="115" aria-hidden="true"/>

                        <div class="agpr-recipientEditor-copilot-text-container">
                            <div class="agpr-recipientEditor-copilot-text agpr-recipientEditor-copilot-text-biggerText"
                                [innerHTML]="'Discover.recipientEditor.agilityAgent.findContacts.description' | localize"
                            >
                            </div>
                        </div>
                        <div class="agpr-recipientEditor-copilot-text-container">
                            <div class="agpr-recipientEditor-copilot-text-moreSpacing"
                                [innerHTML]="'Discover.recipientEditor.agilityAgent.findContacts.text' | localize"
                            >
                            </div>
                        </div>

                        <div class="agpr-recipientEditor-copilot-button">
                            <agpr-button
                                [label]="'Discover.recipientEditor.prCoPilot.findContacts'"
                                [style]="buttonTypes.primary"
                                [disabled]="!distributionId"
                                [tooltip]="!distributionId ? 'Discover.recipientEditor.prCoPilot.noAccess' : ''"
                                (click)="findContacts()"
                            ></agpr-button>
                        </div>
                    </div>
                </div>
            </agpr-scroll-panel>
        </ng-container>
    </div>

</div>

<ng-template let-row="row" let-column="column" #countFetchingCell>
    <div class="agpr-table-row">
        <div class="agpr-count-value">
            <label *ngIf="row.count !== null && !row.countLoading">{{ row.count | number }}</label>
            <label *ngIf="row.count === null && !row.countLoading">- - -</label>
        </div>
        <div class="agpr-count-loader">
            <span
                *ngIf="sourceType === sourceTypes.searches"
                [agprLoading]="row.countLoading"
                [agprInlineLoadingIndicator]="true"
                [loadingSmallIndicator]="true"
            >
                <agpr-button
                    *ngIf="!row.countLoading && !row.editDisabled"
                    [style]="buttonTypes.icon"
                    icon="fa fa-refresh"
                    tooltip="Discover.distribution.actions.getSearchCount"
                    class="agpr-count-loader-reloadIcon"
                    [initiallyFocusable]="false"
                    (click)="fetchSearchCount(row)"
                >
                </agpr-button>
            </span>
        </div>
        <div class="agpr-table-row-infoCircle">
            <ng-container *ngIf="sourceType === sourceTypes.searches || sourceType === sourceTypes.lists">
                <span
                    *ngIf="row.modifiedUser"
                    role="img"
                    class="fa-regular fa-circle-info agpr-recipient-picker-infoCircle"
                    [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                        createdDate: row.createdDate | changeTimeZone: userTimeZone: dateFormat,
                        createdBy: row.createdUser,
                        modifiedDate: row.modifiedDate | changeTimeZone: userTimeZone: dateFormat,
                        modifiedBy: row.modifiedUser
                    }"
                    [initiallyFocusable]="false"
                ></span>
                <span
                    *ngIf="!row.modifiedUser"
                    role="img"
                    class="fa-regular fa-circle-info agpr-recipient-picker-infoCircle"
                    [agprTooltip]="'Tags.manageDialog.tagGroupInformation.unmodified' | localize : {
                        createdDate: row.createdDate | changeTimeZone: userTimeZone: dateFormat,
                        createdBy: row.createdUser
                    }"
                    [initiallyFocusable]="false"
                ></span>
            </ng-container>
        </div>
    </div>
</ng-template>
